import { decorate, injectable } from '@evertel/di'
import { RoomMessagesStore } from './RoomMessagesStore'

class ReplyMessagesStore extends RoomMessagesStore {}

decorate(injectable(), ReplyMessagesStore)

export { ReplyMessagesStore }
